module.exports = __webpack_public_path__ + "img/educacao.94cb0437.svg";